export default "__VITE_ASSET__e8e562d6__$_?nuxt_component=async__"